<template>
  <b-card
    v-if="data"
    class="card-transaction"
    no-body
  >
    <b-card-header>
      <b-card-title>{{ $t('Doctorate Stat') }}</b-card-title>
    </b-card-header>

    <b-card-body>
      <div
        v-for="(count, doctorate) in data"
        :key="doctorate"
        class="transaction-item"
      >
        <b-media no-body>
          <b-media-aside>
            <b-avatar
              rounded
              size="42"
              variant="light-success"
            >
              <feather-icon
                size="18"
                icon="UserIcon"
              />
            </b-avatar>
          </b-media-aside>
          <b-media-body class="my-auto">
            <h6 class="transaction-title">
              {{ $t(`statistics.${doctorate}`) }}
            </h6>
          </b-media-body>
        </b-media>
        <div
          class="font-weight-bolder text-primary"
        >
          {{ count }}
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>
<script>
import {
  BAvatar, BCard, BCardBody, BCardHeader, BCardTitle, BMedia, BMediaAside, BMediaBody,
} from 'bootstrap-vue'

export default {
  name: 'DoctorateStat',
  components: {
    BAvatar, BCardHeader, BCardTitle, BCard, BMedia, BCardBody, BMediaAside, BMediaBody,
  },
  props: {
    isOtm: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: true,
      data: null,
    }
  },
  created() {
    this.loading = true
    this.$store.dispatch(`statistic/get${this.isOtm ? 'Org' : 'Min'}DoctorateStat`).then(({ data }) => {
      this.data = data
      this.loading = false
    })
  },
}
</script>
